import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const Hero = ({ onBookNowClick }) => {
  return (
    <section
      id="home"
      className="relative h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/36377051/pexels-photo-36377051.jpeg?cs=srgb&dl=pexels-charlotteblackcarservice-36377051.jpg&fm=jpg)'
        }}
      >
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-6 animate-fade-in">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white leading-tight">
            LUXURY CHAUFFEUR
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600">
              SERVICE
            </span>
          </h1>
          <p className="text-xl sm:text-2xl md:text-3xl text-gray-300 font-light tracking-wide">
            EXECUTIVE ELECTRIC TRANSPORTATION | FOR THE AFFLUENT COMMUNITY
          </p>
          <p className="text-base sm:text-lg text-gray-400 max-w-2xl mx-auto">
            Experience the pinnacle of sustainable luxury with our premium all-electric fleet.
            Professional chauffeurs, seamless service, zero emissions.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button
              onClick={onBookNowClick}
              size="lg"
              className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black font-bold text-lg px-8 py-6 rounded-full shadow-2xl shadow-amber-500/30 transition-all duration-300 hover:scale-105"
            >
              Book Your Ride
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-black font-semibold text-lg px-8 py-6 rounded-full transition-all duration-300 hover:scale-105"
            >
              View Fleet
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-amber-500 rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;